import React from 'react';

const AchievementCard = ({ title, year, icon: Icon, description }) => (
  <div className="achievement-card" data-testid="achievement-card">
    <div className="achievement-icon">
      <Icon size={32} />
    </div>
    <div className="achievement-content">
      <h4 className="achievement-title">{title}</h4>
      <span className="achievement-year">{year}</span>
      <p className="achievement-description">{description}</p>
    </div>
  </div>
);

export default AchievementCard;
